import { render, staticRenderFns } from "./time_notice_view.vue?vue&type=template&id=3c9cd1c9"
import script from "./time_notice_view.vue?vue&type=script&lang=js"
export * from "./time_notice_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports